<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>实验管理</el-breadcrumb-item>
      <el-breadcrumb-item>实验列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="col-sm-6 pl-0">
      <div class="panel">
        <el-page-header
          @back="$router.go(-1)"
          content="实验详情"
        ></el-page-header>
        <div>
          <div class="row">
            <div class="col-sm-4 form-group">
              <span>实验日期：</span>{{ experiment.day }}
            </div>
            <div class="col-sm-4 form-group">
              <span>实验人：</span>{{ experiment.experimenter }}
            </div>
            <div class="col-sm-4 form-group">
              <span>单号：</span>{{ experiment.order_number }}
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 form-group">
              <span>实验原因：</span>{{ experiment.reason }}
            </div>
          </div>

          <div class="panel-heading">
            <h3 class="panel-title pad-no">设计数据</h3>
          </div>
          <div class="row">
            <div class="col-sm-4 form-group">
              <span>钻具类型：</span>{{ experiment.drill_tool_category }}
            </div>
            <div class="col-sm-4 form-group">
              <span>转子头数：</span>{{ experiment.rotor_head_number }}
            </div>
            <div class="col-sm-4 form-group">
              <span>定子头数：</span>{{ experiment.stator_head_number }}
            </div>
          </div>

          <div class="row">
            <div class="col-sm-4 form-group">
              <span>定子尺寸(mm)：</span>{{ experiment.stator_size }}
            </div>
            <div class="col-sm-4 form-group">
              <span>定子长度(mm)：</span>{{ experiment.stator_length }}
            </div>
            <div class="col-sm-4 form-group">
              <span>过盈范围：</span>{{ experiment.interference_range }}
            </div>
          </div>

          <div class="row">
            <div class="col-sm-4 form-group">
              <span>转子尺寸(mm)：</span>{{ experiment.rotor_size }}
            </div>
            <div class="col-sm-4 form-group">
              <span>转子长度(mm)：</span>{{ experiment.rotor_length }}
            </div>
            <div class="col-sm-4 form-group">
              <span>橡胶类型：</span>{{ experiment.rubber_category }}
            </div>
          </div>

          <div class="panel-heading">
            <h3 class="panel-title pad-no">实测数据</h3>
          </div>
          <div class="row">
            <div class="col-sm-4 form-group">
              <span>整机钢号：</span>{{ experiment.actual_steel_number }}
            </div>
            <div class="col-sm-4 form-group">
              <span>芯轴编号：</span>{{ experiment.actual_mandrel_number }}
            </div>
            <div class="col-sm-4 form-group">
              <span>橡胶类型：</span>{{ experiment.actual_rubber_category }}
            </div>
          </div>

          <div class="row">
            <div class="col-sm-4 form-group">
              <span>定子尺寸(mm)：</span>{{ experiment.actual_stator_size }}
            </div>
            <div class="col-sm-4 form-group">
              <span>定子长度(mm)：</span>{{ experiment.actual_stator_length }}
            </div>
            <div class="col-sm-4 form-group">
              <span>定子钢号：</span>{{ experiment.actual_stator_steel_number }}
            </div>
          </div>

          <div class="row">
            <div class="col-sm-4 form-group">
              <span>转子尺寸(mm)：</span>{{ experiment.actual_rotor_size }}
            </div>
            <div class="col-sm-4 form-group">
              <span>转子长度(mm)：</span>{{ experiment.actual_rotor_length }}
            </div>
            <div class="col-sm-4 form-group">
              <span>转子钢号：</span>{{ experiment.actual_rotor_steel_number }}
            </div>
          </div>

          <div class="row">
            <div class="col-sm-4 form-group">
              <span>过盈量(mm)：</span>{{ experiment.actual_interference }}
            </div>
            <div class="col-sm-4 form-group">
              <span>镀层类型：</span>{{ experiment.actual_plating_category }}
            </div>
            <div class="col-sm-4 form-group">
              <span>镀层厚度(mm)：</span
              >{{ experiment.actual_plating_thickness }}
            </div>
          </div>

          <div class="panel-heading">
            <h3 class="panel-title pad-no">实验结果及处理意见</h3>
          </div>
          <div class="row">
            <div class="col-sm-12 form-group">{{ experiment.remark }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-6">
      <div class="panel">
        <div class="panel-heading">
          <h3 class="panel-title">测量数据</h3>
        </div>
        <div>
          <div class="table-responsive">
            <table class="table table-bordered table-vcenter">
              <thead>
                <tr>
                  <th class="text-center">阶段</th>
                  <th class="text-center">转速(rpm)</th>
                  <th class="text-center">
                    流量({{ flowUnitOptions[experiment.flow_unit] }})
                  </th>
                  <th class="text-center">
                    扭矩({{ torqueUnitOptions[experiment.torque_unit] }})
                  </th>
                  <th class="text-center">压力(MPa)</th>
                  <th class="text-center">总效率(100%)</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="measuring in experiment.measurings"
                  :key="measuring.id"
                >
                  <td class="text-center">
                    {{ measuringCategories[measuring.category] }}
                  </td>
                  <td class="text-center">{{ measuring.rotating_speed }}</td>
                  <td class="text-center">{{ measuring.flow }}</td>
                  <td class="text-center">{{ measuring.torque }}</td>
                  <td class="text-center">{{ measuring.pressure }}</td>
                  <td class="text-center">{{ measuring.efficiency }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { experimentDetail } from '../../../service/getData'
export default {
  data() {
    return {
      experiment: {},
      measuringCategories: {
        1: '启动',
        2: '增加扭矩',
        3: '结束',
      },
      flowUnitOptions: {
        1: 'gpm',
        2: 'lpm',
      },
      torqueUnitOptions: {
        1: 'ft*lbf',
        2: 'Nm',
      },
    }
  },
  created() {
    this.getData(this.$route.params.id)
  },
  methods: {
    async getData(id = 0) {
      let res = await experimentDetail(id)
      console.log(res)
      if (res.code == 0) {
        this.experiment = res.data
      }
    },
  },
}
</script>
